import { createFileRoute, redirect } from '@tanstack/react-router'

// "/" → "/budget". The budget table is the home screen for any
// signed-in user. Unauthenticated state is handled at the root layout
// (renders the sign-in screen instead of the routed view).
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/budget' })
  },
})
